var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{directives:[{name:"touch",rawName:"v-touch",value:({
    start: function () { return _vm.clicked(); },
  }),expression:"{\n    start: () => clicked(),\n  }"}],attrs:{"id":"btn","contain":"","src":_vm.btnImage,"height":_vm.btnHeight,"width":_vm.btnWidth}},[_c('div',{staticClass:"mt-3",attrs:{"id":"`btnText"}},[_vm._v(_vm._s(_vm.btnText))])])}
var staticRenderFns = []

export { render, staticRenderFns }